<template>
    <div class="video-pre">
        <div class="video-header">预览</div>
        <div class="video-wrapper">
          <video
            id="myVideo"
            class="video-js vjs-default-skin vjs-big-play-centered"
            controls
            preload="auto"
          >
          </video>
        </div>
    </div>
</template>

<script>
import videojs from '../../../static/js/video.min.js'
import 'videojs-contrib-hls'
export default {
    name: "videopre",
    data() {
      return {
        name:'',
        videoUrl: ''
      };
    },
    methods:{
      getUrl () {
        this.$api.GETMEDIAURL({
          mediaId: this.$route.params.id
        }).then(res => {
          if (res.retcode === 0) {
            this.videoUrl = res.data.url
            this.myVideo = videojs('myVideo', {
              bigPlayButton: true,
              textTrackDisplay: false,
              posterImage: false,
              errorDisplay: false,
              hls: {
                withCredentials: true
              }
            })
            this.myVideo.src({
              src: this.videoUrl,
              type: 'application/x-mpegURL'
            })
          } else {
            this.$message.error(res.message)
          }
        })
      }
    },
    mounted () {
      this.getUrl()
      document.title = '查看附件'
    }
}
</script>
<style scoped>
    .video-pre{
      width: 1200px;
      margin: auto;
      background: #f4f8f9;
    }
    #myVideo{
      width: 100%;
      height: 100%;
    }
    .video-wrapper{
      width: 100%;
      height: 675px;
    }
    .video-header{
      display: block;
      width:100%;
      padding: 30px 0 28px;
      margin-bottom: 0px;
      text-align: center;
      font-size: 18px;
    }
</style>
<style>
</style>



// WEBPACK FOOTER //
// src/pages/video-preview/index.vue